export const SCAN_AND_UPLOAD_PETITIONS_REQUEST = 'SCAN_AND_UPLOAD_PETITIONS_REQUEST';
export const SCAN_AND_UPLOAD_PETITIONS_SUCCESS = 'SCAN_AND_UPLOAD_PETITIONS_SUCCESS';
export const SCAN_AND_UPLOAD_PETITIONS_FAILED = 'SCAN_AND_UPLOAD_PETITIONS_FAILED';

export const RESET_BATCH_SCAN_AND_UPLOAD = 'RESET_BATCH_SCAN_AND_UPLOAD';
